import {getCreateDCSCategoryUrl, getEditDCSCategoryUrl} from '../../../../constants/urls';
import {postRequest, putRequest} from '../../../../middlewares/api/actions';

export const BUILDER_CATEGORY_FORM_CREATE = 'BUILDER_CATEGORY_FORM_CREATE';
export const BUILDER_CATEGORY_FORM_HIDE = 'BUILDER_CATEGORY_FORM_HIDE';
export const BUILDER_CATEGORY_FORM_CREATE_SUBMIT = 'BUILDER_CATEGORY_FORM_CREATE_SUBMIT';
export const BUILDER_CATEGORY_FORM_EDIT_SUBMIT = 'BUILDER_CATEGORY_FORM_EDIT_SUBMIT';
export const BUILDER_CATEGORY_FORM_CHANGE = 'BUILDER_CATEGORY_FORM_CHANGE';
export const BUILDER_CATEGORY_FORM_PARENT_MODAL_SHOW = 'BUILDER_CATEGORY_FORM_PARENT_MODAL_SHOW';
export const BUILDER_CATEGORY_FORM_PARENT_MODAL_HIDE = 'BUILDER_CATEGORY_FORM_PARENT_MODAL_HIDE';

export const createBuilderCategoryForm = parCode => ({
  type: BUILDER_CATEGORY_FORM_CREATE,
  parCode
});

export const hideBuilderCategoryForm = () => ({
  type: BUILDER_CATEGORY_FORM_HIDE
});

export const changeBuilderCategoryForm = fields => ({
  type: BUILDER_CATEGORY_FORM_CHANGE,
  fields
});

export const submitBuilderCategoryFormCreate = cat => postRequest(
  BUILDER_CATEGORY_FORM_CREATE_SUBMIT,
  getCreateDCSCategoryUrl(),
  {
    catCode: cat.CatCode,
    parCode: cat.ParCode,
    ord: cat.Ord,
    labels: cat.labels
  },
  t => ({
    success: t('scenes.dataManager.builder.categoryForm.messages.create.success')
  })
);

export const submitBuilderCategoryFormEdit = cat => putRequest(
  BUILDER_CATEGORY_FORM_EDIT_SUBMIT,
  getEditDCSCategoryUrl(),
  [{
    idCat: cat.IDCat,
    catCode: cat.CatCode,
    parCode: cat.ParCode,
    ord: cat.Ord,
    labels: cat.labels
  }],
  t => ({
    success: t('scenes.dataManager.builder.categoryForm.messages.edit.success')
  })
);

export const showBuilderCategoryFormParentModal = () => ({
  type: BUILDER_CATEGORY_FORM_PARENT_MODAL_SHOW
});

export const hideBuilderCategoryFormParentModal = () => ({
  type: BUILDER_CATEGORY_FORM_PARENT_MODAL_HIDE
});


// WEBPACK FOOTER //
// ./src/scenes/data-manager/builder/category-form/actions.js